export const POLICY_LANGUAGE_CODE = 'ru'
